import React from 'react';
import NumericFunction from "../../../utils/NumericFunction";
import commaSeparator from "../../../utils/CommaSeparator";

const MultiData = ({multiData, changeTe, changePriceHandler, deleteRowHandler,}) => {

  try {
    return (
      <>
        {multiData.map((v, index) => {
            return <ul className="row-side" key={"row" + index}>
              <li style={{width: "5%"}}>{index + 1}</li>
              <li style={{width: "30%"}}>{v.NameKala}</li>
              <li style={{width: "15%"}}>
                <input type="text" value={"" + NumericFunction.e2p(commaSeparator(v.price)) + ""}
                       onChange={e => changePriceHandler(e, v.uniqId)}
                />
              </li>
              <li style={{width: "15%"}}>{v.color}</li>
              <li style={{width: "15%"}}>{v.size}</li>
              <li style={{width: "15%"}}>
                <input type="text" value={v.internetId} onChange={e => changeTe(e, v.uniqId)}/>
              </li>
              <li style={{width: "5%"}} className={"delete-side"} onClick={() => deleteRowHandler(v.uniqId)}>
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <g opacity="0.99">
                    <path
                      d="M20.6829 21.7435L12.1976 13.2582C11.9077 12.9683 11.9077 12.4875 12.1976 12.1976C12.4875 11.9077 12.9684 11.9077 13.2583 12.1976L21.7435 20.6829C22.0335 20.9728 22.0335 21.4536 21.7435 21.7435C21.4536 22.0334 20.9728 22.0334 20.6829 21.7435Z"
                      fill="#F84459"/>
                    <path
                      d="M12.1976 21.7435C11.9077 21.4536 11.9077 20.9728 12.1976 20.6829L20.6829 12.1976C20.9728 11.9077 21.4536 11.9077 21.7436 12.1976C22.0335 12.4875 22.0335 12.9683 21.7436 13.2582L13.2583 21.7435C12.9684 22.0334 12.4875 22.0334 12.1976 21.7435Z"
                      fill="#F84459"/>
                  </g>
                </svg>
              </li>
            </ul>
          }
        )}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default MultiData;